import { createContext } from 'react';

export const SearchApiRequestContext = createContext({ requestCacheKey: '' });
